// extracted by mini-css-extract-plugin
module.exports = {"header":"tablebooking_header__2HAkU","icon":"tablebooking_icon__1SA6T","button":"tablebooking_button__3vzs1"};